import { AppState } from '../../bootstrap/redux/state/AppState';
import { ContainerInfoState } from '../state/ContainerInfoState';

export function selectContainerInfo(state: AppState): ContainerInfoState {
    return state.containerInfo;
}